// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const Incentive = {};

Incentive.postIncentive = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

Incentive.getAddIncentive = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/getAdd?prospectid=${data.prospectid}`,
    method: "get",
  });
};

Incentive.getEditIncentive = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/getEdit?prospectid=${data.prospectid}`,
    method: "get",
  });
};

Incentive.editIncentive = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/edit`,
    method: "put",
    headers: {
      "x-requestId": data.incentiveId,
    },
    data: data.data,
  });
};

Incentive.deletIncentive = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/delete`,
    method: "delete",
    headers: {
      "x-requestId": data.incentiveId,
    },
    data: {
      Notes: "",
    },
  });
};

Incentive.Proceed = function (data) {
  return lossClient({
    url: `/ApkLoanKTAIncentive/Proceed`,
    method: "put",
    headers: {
      "x-requestId": data.lonId,
    },
    data: {
      UserId: data.userId,
    },
  });
};

export default Incentive;
